const DIRECT_IMAGE_INPUT_KEYS = ['image', 'start_image', 'end_image'] as const

export function attachUploadedImageInputsToActionRequests<T>(
    actionRequests: T,
    imageSignedIds: string[] | string | null,
): T {
    if (!Array.isArray(actionRequests) || !imageSignedIds) return actionRequests
    const signedIds = Array.isArray(imageSignedIds) ? imageSignedIds : [imageSignedIds]

    return actionRequests.map(action => {
        if (!action || typeof action !== 'object') return action
        const actionRecord = action as Record<string, any>
        const inputs = actionRecord.inputs || {}
        const resolvedInputs = { ...inputs }
        let changed = false

        const resolve = (input: any) => {
            if (!input?.pending_upload || input.source !== 'answer_image') return input
            const index = input.index ?? 0
            const signedId = Number.isInteger(index) && index >= 0 ? signedIds[index] : null
            if (!signedId) return input
            changed = true
            return {
                ...input,
                source: 'answer_image',
                index,
                url: null,
                signed_id: signedId,
                pending_upload: false,
            }
        }
        DIRECT_IMAGE_INPUT_KEYS.forEach(key => {
            if (Object.prototype.hasOwnProperty.call(inputs, key))
                resolvedInputs[key] = resolve(inputs[key])
        })
        if (Array.isArray(inputs.references?.images)) {
            resolvedInputs.references = {
                ...inputs.references,
                images: inputs.references.images.map(resolve),
            }
        }

        return changed ? { ...actionRecord, inputs: resolvedInputs } : action
    }) as T
}
